export interface BaseUser {
  readonly id: number;
  readonly username: string;
  readonly description?: string;
  readonly enabled: boolean;
  readonly createdAt: string;
  readonly updatedAt: string;
  readonly metadata?: any;
  readonly namespaces: string[];
  readonly namespacesUpload: string[];
}

export interface User extends BaseUser {
  readonly role: Role;
  readonly namespaces: string[];
}

export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER',
  OPERATOR = 'OPERATOR',
}

export const RolesLabel = new Map<string, string>([
  [Role.ADMIN, 'AMMINISTRATORE'],
  [Role.USER, 'UTENTE'],
  [Role.OPERATOR, 'OPERATORE'],
]);

export interface UserRole {
  readonly key: Role;
  readonly value: string;
}

